module.exports = __webpack_public_path__ + "img/zain.34c8b217.png";